module.exports = __webpack_public_path__ + "img/draw line.bb054ba2.svg";